import Icon from './Icon'
import NoNotificationsIcon from './noNotificationsIcon'

export const NO_NOTIFICATIONS_ICON = NoNotificationsIcon
export default Icon
